import { ordersData } from './orders.data';
import type { IGetOrderRequest, IGetOrdersRequest } from './orders.dto';
import { mapOrderDetail, mapOrderList } from './orders.mappers';

export const ordersService = {
  getOrders: async (filters: IGetOrdersRequest) => mapOrderList(await ordersData.getOrders(filters)),
  getOderDetail: async (data: IGetOrderRequest) => mapOrderDetail(await ordersData.getOderDetail(data)),
};

export default ordersService;
